<template>
  <div class="backTo">
    <Button
      :href="link"
      :label="label"
      :handleClick="
        () => {
          $router.push(link)
        }
      "
    />
  </div>
</template>

<script lang="ts">
import Button from '@/components/elements/Button.vue'

export default {
  name: 'BackTo',

  components: {
    Button
  },

  props: {
    link: String,
    label: {
      type: String,
      default: '戻る'
    }
  }
}
</script>

<style lang="scss">
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.backTo {
  margin-top: 40px;
  // margin-left: -16px;
  // margin-right: -16px;
  // padding: 16px 0;
  // background-color: var.$color-other-bg;
  //ボタン176px

  // @include mixins.media() {
  //   // background-color: transparent;
  //   padding-bottom: 32px;
  // }
}
</style>
